import { configurationTypes } from '@/configuration/pages/ConfigurationPage/constants'
import configurationServices from '@/configuration/services/services'

export const servicesByConfigurationMode = {
  [configurationTypes.merchant]: {
    getDetailEmailTemplate: configurationServices.getMerchantDetailEmailTemplate,
    editDetailEmailTemplate: configurationServices.editMerchantDetailEmailTemplate,
    createEmailTemplate: configurationServices.createMerchantEmailTemplate,
  },
  [configurationTypes.returnsPortal]: {
    getDetailEmailTemplate: configurationServices.getPortalDetailEmailTemplate,
    editDetailEmailTemplate: configurationServices.editPortalDetailEmailTemplate,
    createEmailTemplate: configurationServices.createPortalEmailTemplate,
  },
}
